
/**
 * @param {{commonHeader:string}} data
 */
import React, { useEffect, useState } from "react";
import TossUpChallenge from "../../components/TossUpChallenge";
import BannerAd from "../../components/BannerAd";
import PageMeta from "../../components/PageMeta";
import AnalyticsPageLoad from "../../components/AnalyticsPageLoad/AnalyticsPageLoad";
import { fetchTossUpChallenge } from "../../api/cms";

import "./styles.scss";

const TossUpChallengePage = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [ad, setAd] = useState({});
  const [googleAd, setGoogleAd] = useState({});
  const [ogMetaTags, setOgMetaTags] = useState({});
  const [twitterMetaTags, setTwitterMetaTags] = useState({});
  const [tossUpProps, setTossUpProps] = useState({});
  const [sitePageTitle, setPageTitle] = useState("Toss Up Challenge");
  const [basicMetaTags, setBasicMetaTags] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      const data = await fetchTossUpChallenge();
      if (data.error === true) {
        return;
      }
      const {
        ad,
        config,
        page,
        puzzles: { rows },
      } = data;
      setIsLoaded(true);
      setAd(ad);
      setGoogleAd(googleAd);
      setTossUpProps({ puzzles: rows, config });

      if (data.page && data.page.page_title && data.page.page_title !== "") {
        setPageTitle(data.page.page_title);
      }

      if (data.page && data.page.basic_meta_tags && data.page.basic_meta_tags !== "") {
        setBasicMetaTags(data.page.basic_meta_tags);
      }


      if (data.page && data.page.og_meta_tags && data.page.og_meta_tags !== "") {
        setOgMetaTags(data.page.og_meta_tags);
      }
      if (data.page && data.page.page_title && data.page.page_title !== "") {
        setPageTitle(data.page.page_title);
      }

      if (data.page && data.page.basic_meta_tags && data.page.basic_meta_tags !== "") {
        setBasicMetaTags(data.page.basic_meta_tags);
      }

      if (data.page && data.page.twitter_meta_tags && data.page.twitter_meta_tags !== "") {
        setTwitterMetaTags(data.page.twitter_meta_tags);
      }
    };

    fetchData();
  }, []);

  const { puzzles = null, config = null } = tossUpProps;

  return (
    <div className="">
      <PageMeta 
      sitePageTitle={sitePageTitle}
      ogMetaTags={ogMetaTags}
      basicMetaTags={basicMetaTags}
      twitterMetaTags={twitterMetaTags} />
      {isLoaded && (
        <AnalyticsPageLoad contentTitle={config && config.commonHeader} />
      )}
      <TossUpChallenge puzzles={puzzles} config={config} />
      {ad && Object.keys(ad).length !== 0 && ad.image && (
        <BannerAd image={ad.image} url={ad.url} />
      )}
    </div>
  );
};

export default TossUpChallengePage;
